// ─────────────────────────────────────────────────────────────────────────────
// Bölüm Kayıt Defteri — Site bölümleri ile editörlerini eşler.
// Hem Ana Sayfa editör sekmesi hem de Görsel Editör bu listeyi kullanır.
// section.id değeri, site bileşenlerindeki data-edit="..." ile birebir aynıdır.
// ─────────────────────────────────────────────────────────────────────────────
import type { ComponentType } from "react";
import {
  HeroEditor, FeaturesEditor, SolutionsEditor, ProductsEditor,
  TestimonialsEditor, CTAEditor, StoriesEditor, HpBannerEditor, OfficesEditor,
} from "./index";
import PartnersEditor from "../components/PartnersEditor";
import AboutEditor from "../components/AboutEditor";

type EditorComp = ComponentType<{ onSaved?: () => void }>;

const PartnersSection: EditorComp = () => <PartnersEditor />;
const AboutSection: EditorComp = () => <AboutEditor />;

export interface SectionDef {
  id: string;       // data-edit ile aynı
  label: string;    // sitedeki bölüm adıyla aynı
  icon: string;
  Editor: EditorComp;
}

export interface PageDef {
  id: string;
  label: string;
  path: string;     // iframe önizleme yolu
  sections: SectionDef[];
}

// Ana sayfa bölümleri — sitede göründükleri sırayla
const HOME_SECTIONS: SectionDef[] = [
  { id: "hero",         label: "Hero (Üst Alan)",     icon: "ri-layout-top-line",      Editor: HeroEditor },
  { id: "features",     label: "Neden C2TEK?",         icon: "ri-star-line",            Editor: FeaturesEditor },
  { id: "solutions",    label: "Çözümlerimiz",         icon: "ri-apps-2-line",          Editor: SolutionsEditor },
  { id: "testimonials", label: "Referanslar",          icon: "ri-double-quotes-l",      Editor: TestimonialsEditor },
  { id: "partners",     label: "Stratejik Ortaklar",   icon: "ri-links-line",           Editor: PartnersSection },
  { id: "stories",      label: "Öğretici Makaleler",   icon: "ri-article-line",         Editor: StoriesEditor },
  { id: "hpbanner",     label: "HP Yetkili Servis",    icon: "ri-tools-line",           Editor: HpBannerEditor },
  { id: "offices",      label: "Ofislerimiz",          icon: "ri-map-pin-line",         Editor: OfficesEditor },
  { id: "cta",          label: "Çağrı Bölümü (CTA)",   icon: "ri-megaphone-line",       Editor: CTAEditor },
];

export const PAGES: PageDef[] = [
  { id: "home",     label: "Ana Sayfa",          path: "/",                       sections: HOME_SECTIONS },
  { id: "about",    label: "Hakkımızda",         path: "/hakkimizda",             sections: [{ id: "about", label: "Hakkımızda İçeriği", icon: "ri-information-line", Editor: AboutSection }] },
  { id: "products", label: "Ürünlerimiz",        path: "/urunler",                sections: [{ id: "products", label: "Ürün Kataloğu", icon: "ri-computer-line", Editor: ProductsEditor }] },
  { id: "partners", label: "Stratejik Ortaklar", path: "/stratejik-ortaklarimiz", sections: [{ id: "partners", label: "Ortak Listesi", icon: "ri-links-line", Editor: PartnersSection }] },
];

export { HOME_SECTIONS };
